import { render, staticRenderFns } from "./ApiPage.vue?vue&type=template&id=3df5704d"
import script from "./ApiPage.vue?vue&type=script&lang=js"
export * from "./ApiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports